$(function () {
	/* == Element Selectors ============================================== */
	/* =================================================================== */

	const body = $("body");
	const header = $(".j-site-header");
	const footer = $(".j-site-footer");
	const nav = $(".j-site-nav");
	const announcementBar = $(".j-announcement-bar");
	const announcementBarSpacer = $(".j-announcement-bar-spacer");

	/* == Responsive Breakpoints ========================================= */
	/* == Breakpoints are mobile first ============================= */

	const xl_breakpoint = 1200;
	const lg_breakpoint = 1024;
	const sm_breakpoint = 640;

	// Create a media query matcher
	const mobileMediaQuery = window.matchMedia(`(max-width: ${lg_breakpoint - 1}px)`);

	// Handle media query changes
	function handleMobileChange(e) {
		resetMobileMenus();
	}

	// Listen for changes
	mobileMediaQuery.addEventListener('change', handleMobileChange); // Modern browsers

	/* == Viewport Height ================================================ */
	/* == Sets and updates a vh unit to be used by elements that are ===== */
	/* == full height or proportional to the current viewport height ===== */

	function setInnerViewportHeight() {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);
	}

	setInnerViewportHeight();

	window.addEventListener("resize", setInnerViewportHeight);

	// update quantity on single-product-section

	$(document).on(
		"click",
		".single-product-section .qty-selection button",
		function (e) {
			e.preventDefault();

			var input = $(this).parent().find(".j-quantity-update");
			var max = input.attr("max");

			console.log("max", max);

			if ($(this).hasClass("minus")) {
				if (input.val() < 2) {
					console.log("smaller than 0");
				} else {
					var counter = parseInt(input.val());

					if (!(counter > max)) {
						counter--;
						input.val(counter);
					}
				}
			}

			if ($(this).hasClass("plus")) {
				var counter = parseInt(input.val());

				if (counter != max) {
					counter++;
					input.val(counter);
				}
			}

			$(".single-product-section .block-wrapper .j-add-to-cart").attr(
				"data-qty",
				counter
			);
		}
	);

	/* == Viewport Width ================================================ */
	/* == Sets and updates a vw unit to be used by elements that are ===== */
	/* == full width or proportional to the current viewport width ======= */

	function setInnerViewportWidth() {
		let scrollbarWidth =
			(window.innerWidth - document.body.clientWidth) * 0.01;
		let vw;

		if (scrollbarWidth) {
			vw = document.body.clientWidth * 0.01;
		} else {
			vw = window.innerWidth * 0.01;
		}

		document.documentElement.style.setProperty("--vw", `${vw}px`);
	}

	setInnerViewportWidth();

	window.addEventListener("resize", setInnerViewportWidth);

	/* == Main Scroll Event Listener ===================================== */
	/* == Apply logic here that can be used on every page ================ */
	/* == Set to 'passive' to improve scroll performance, see  =========== */
	/* == https://web.dev/uses-passive-event-listeners/ for more info  === */

	window.addEventListener(
		"scroll",
		function (e) {
			setInnerViewportHeight();
		},
		{ passive: true }
	);

	/* == Scrolling Text Effect=============================== */
	/* == Creates a flexible marquee effect ================== */

	let scrollDurationMultiplier = 40; // larger = faster

	if (window.theme_marquee_scroll_speed) {
		switch (window.theme_marquee_scroll_speed) {
			case "slow":
				scrollDurationMultiplier = 25;
				break;
			case "medium":
				scrollDurationMultiplier = 40;
				break;
			case "fast":
				scrollDurationMultiplier = 55;
				break;
			default:
				break;
		}
	}

	/**
	 *
	 * @param {object} options
	 * @param {string} options.classes - CSS classes to be applied to each cloned element
	 * @param {string} options.selector - JQuery selector used find which element to clone
	 * @param {string} options.parentSelector - JQuery selector used to find the parent element
	 */

	function initMarquee({
		classes = "marquee-text j-marquee-text",
		selector = ".j-marquee-text",
		parentSelector = ".j-marquee",
	} = {}) {
		const originals = $(selector);
		const original = originals.first();
		let copies = Math.floor($(window).outerWidth() / original.width());

		if (originals.length > copies) {
			originals.each(function (index) {
				if (index > 0) {
					$(this).remove();
				}
			});

			const container = $(parentSelector);
			const scrollSpeed = original.width() / scrollDurationMultiplier;

			container.css("--duration", `${scrollSpeed}s`);

			for (let i = 1; i < 3; i++) {
				const clone = original.clone();

				// remove old classes and add correct offset classes
				clone.removeClass();
				clone.addClass(`${classes}`);

				let scrollOffset = i * 100;
				clone.css({ "--offset": `${scrollOffset}%` });

				clone.appendTo(container);
			}

			original.css({ "--offset": `0%` }).removeClass("hidden");

			container.addClass("marquee animate").removeClass("hidden");

			return true;
		} else {
			original.removeClass("hidden");

			return false;
		}
	}

	// Start

	if ($(".j-marquee").length) {
		function setupMarquee() {
			const marqueeSection = document.querySelector(
				".j-announcement-bar"
			);
			const marquee = document.querySelector(".j-marquee");
			const isScrollable = initMarquee();

			function getMarqueeTextWidth() {
				return document
					.querySelectorAll(".j-marquee-text")[0]
					.getBoundingClientRect().width;
			}

			function pauseScroll(e) {
				if (e.target === marqueeSection) {
					const textNodes =
						document.querySelectorAll(".j-marquee-text");

					let reset = false;
					let firstOffset = 0;

					textNodes.forEach(function (node, index) {
						// get the current offset for this node
						const style = window.getComputedStyle(node);

						// create a 3D transform matrix
						const matrix = new DOMMatrix(style.transform);
						let translateX =
							(matrix.m41 / getMarqueeTextWidth()) * 100;

						// if the first element is translated by more than 100%
						// we want to 'reset' the translate properties
						if (index === 0) {
							firstOffset = translateX;

							if (translateX < -100) {
								reset = true;
							}
						}

						let resetValue = 0;

						if (reset) {
							// translateX = translateX + 100;
							resetValue = 100;
						}

						let newTranslateX =
							firstOffset + index * 100 + resetValue;

						// add the translateX valu onto the element as a style tag so that when
						// the animation restarts it does so from the right place
						node.style = `--offset: ${newTranslateX}%`;
					});

					marquee.style = `--animation: scrollPause;`;
				}
			}

			function restartScroll(e) {
				if (e.target === marqueeSection) {
					const duration =
						getMarqueeTextWidth() / scrollDurationMultiplier;

					marquee.style = `--animation: scroll; --duration: ${duration}s`;
				}
			}

			if (!isScrollable) {
				marqueeSection.removeEventListener("mouseenter", pauseScroll);
				marqueeSection.removeEventListener("mouseleave", restartScroll);
			} else {
				marqueeSection.addEventListener("mouseenter", pauseScroll);
				marqueeSection.addEventListener("mouseleave", restartScroll);
			}
		}

		setupMarquee();
	}

	/* == Cookie Management ============================================== */
	/* =================================================================== */

	$(document).on("click", ".j-close-newsletter-popup", function (e) {
		e.preventDefault();
		$(".section--newsletter-popup").addClass("hidden");
		$(body).removeClass("locked");
		Cookies.set("newsletter_popup", "true");
	});

	// Show newsletter popup if cookie not set
	const newsletter_cookie = Cookies.get("newsletter_popup");

	if (!newsletter_cookie) {
		const clientTimeout = $(".j-newsletter-modal").data("timeout");
		console.log(clientTimeout);
		const timeout = clientTimeout ? parseInt(clientTimeout) * 1000 : 10000;

		setTimeout(function () {
			if ($(".section--cart-container").hasClass("hidden")) {
				$(".section--newsletter-popup").removeClass("hidden");
				$(body).addClass("locked");
			}
		}, timeout);
	}

	/* == Cart Logic ===================================================== */
	/* =================================================================== */

	// Initialise CartJS
	CartJS.init(window.cart);

	function addToCart({ vid, qty = 1, properties = {} }, callback) {
		if (!vid) {
			// Require a Variant ID
			throw Error("A variant ID (vid) must be provided");
		} else {
			console.log("props klev", properties);
			CartJS.addItem(vid, qty, properties, {
				success: function (data, textStatus, jqXHR) {
					if (callback) {
						callback(null, data);
					}
				},
				error: function (jqXHR, textStatus, errorThrown) {
					console.error("Cart.js Error");

					if (callback) {
						callback(jqXHR);
					} else {
						console.log(jqXHR);
						console.error(errorThrown);
					}
				},
			});
		}
	}

	$(document).on("click", ".j-add-to-cart", function (e) {
		e.preventDefault();

		// get the data required for CartJS
		const vid = $(this).attr("data-vid");
		const qty = $(this).attr("data-qty") || 1;
		const properties = $(this).attr("data-properties");

		// console.log('properties', properties);
		// console.log('properties JSON', JSON.stringify(properties));
		// console.log('properties parse', JSON.parse(properties)._tags);

		// cache the target's original content in case we need to re-use it
		const originalTargetContent = $(this).html();

		// try and add the item to cart
		addToCart({ vid, qty, properties }, function (err, data) {
			if (err) {
				console.log(err);
			} else {
			}
		});
	});

	$(document).on("click", ".j-sps-add-to-cart", function (e) {
		e.preventDefault();

		// get the data required for CartJS
		const vid = $(this).attr("data-vid");
		const qty = $(this).attr("data-qty") || 1;
		const tags = $(this).attr("data-properties");
		const properties = { _tags: tags };

		// console.log('properties', properties);
		// console.log('properties JSON', JSON.stringify(properties));
		// console.log('properties parse', JSON.parse(properties)._tags);

		// cache the target's original content in case we need to re-use it
		const originalTargetContent = $(this).html();

		// try and add the item to cart
		addToCart({ vid, qty, properties }, function (err, data) {
			if (err) {
				console.log(err);
			} else {
			}
		});
	});

	$(document).on("itemAdded", function (event, cart) {

		$(".j-toggle-cart.cart-icon").addClass("animate");
		$(".j-cart-sidebar").addClass("open");
		$(".section--cart-container").removeClass("hidden");
		$(body).addClass("locked");

		setTimeout(function () {
			$(".j-toggle-cart.cart-icon").removeClass("animate");
			$(".j-cart-sidebar").removeClass("open");
			$(".section--cart-container").addClass("hidden");
			$(body).removeClass("locked");
		}, 4000);
	});

	/* == Toggle the Cart ================================================ */

	$(document).on("click", ".j-toggle-cart", function (e) {
		e.preventDefault();

		$(".j-cart-sidebar").toggleClass("open");
		$(".section--cart-container").toggleClass("hidden");
		$(body).toggleClass("locked");
		// if($(body).hasClass("locked")){
		// 	$(body).removeClass("locked")
		// }
		// else{
		// 	$(body).addClass("locked")
		// }
	});

	/* == Shopify Cart API incorrect total price Workaround 26/7/2024 ==== */

	$(document).on('cart.requestComplete', function(event,cart) {
		jQuery.getJSON('/cart.js', function(cart) {
			jQuery(document).trigger('cart.afterManualUpdate', [cart]);
		})
    });

	/* == Hide the Cart ================================================== */

	$(document).on("click", ".j-cart-container", function (e) {
		if (e.target !== this) return;

		$(".j-cart-sidebar").removeClass("open");
		$(".section--cart-container").addClass("hidden");
		$(body).removeClass("locked");
	});

	/* == Click Listeners ================================================ */
	/* =================================================================== */

	/* == Global Mobile Nav ============================================== */

	$(document).on("click", ".j-mobile-menu-open", function () {
		header.addClass("nav-open");
		autoOpenMobileMenus();
	});

	$(document).on("click", ".j-mobile-menu-close", function () {
		header.removeClass("nav-open");
	});

// Function to reset all mobile menu states
function resetMobileMenus() {
	if ($(window).outerWidth() < lg_breakpoint) {
		// Close all top-level dropdowns
		$(".j-sub-menu-toggle .top-level-link").removeClass("open");
		$(".j-dropdown").removeClass("open").removeAttr("style");
		
		// Close all sub-menu links (matching the pattern in .j-close-sub-menu)
		$(".j-toggle-sub-menu-links").each(function () {
			const $parent = $(this).parent();
			if ($parent.hasClass("open")) {
				$parent.removeClass("open");
				$parent.next().hide();
			}
		});
	} else {
		// Desktop: close mobile nav if it's open
		header.removeClass("nav-open");
		
		// Ensure sub-menu-links are visible
		$(".sub-menu-links").css("display", "");
		
		// Clean up mobile-specific classes
		$(".j-sub-menu-toggle .top-level-link").removeClass("open");
		$(".j-dropdown").removeClass("open").removeAttr("style");
		$(".j-toggle-sub-menu-links").parent().removeClass("open");
	}
}

// Function to automatically open default mobile menus
function autoOpenMobileMenus() {
	if ($(window).outerWidth() < lg_breakpoint) {

		// Open only the first non-desktop-only sub-menu in each dropdown
		$(".j-dropdown").each(function () {
			const $firstToggle = $(this).find(".sub-menu:not(.desktop-only) .j-toggle-sub-menu-links").first();
			
			if ($firstToggle.length) {
				$firstToggle.parent().addClass("open");
				$firstToggle.parent().next().show();
			}
		});
	}
}


	// Slide Toggle the top level links on mobile
	$(document).on("click", ".j-sub-menu-toggle .top-level-link", function (e) {
		if ($(window).outerWidth() < lg_breakpoint) {
			e.preventDefault();

			const title = $(this).attr("data-title");

			const listContainer = $(this).siblings(".j-dropdown");

			function getHeight(container) {
				const filters = container.children(".dropdown-inner");
				const filterHeight = filters.outerHeight();

				return (
					20 +
					filters.length * filterHeight +
					(filters.length - 1) * 15
				);
			}

			const listHeight = getHeight(listContainer);

			if (listContainer.hasClass("open")) {
				listContainer.css({ height: `${listHeight}px` });
				requestAnimationFrame(function () {
					listContainer.removeAttr("style");
					listContainer.removeClass("open");
				});
				$(this).removeClass("open");
			} else {
				listContainer.css({
					height: `${listHeight}px`,
					"padding-bottom": "20px",
				});
				listContainer.addClass("open");
				$(this).addClass("open");
			}

			function removeHeightOverride() {
				if (!$(this).hasClass("open")) {
					// do nothing
				} else {
					$(this).css({ height: "auto" });
				}

				listContainer.off("transitionend", removeHeightOverride);
			}

			listContainer.on("transitionend", removeHeightOverride);
		}
	});

	// enable nav dropdowns to function correctly on large touch devices
	$(document).on("click", ".j-sub-menu-toggle", function () {
		if ($(window).outerWidth() >= lg_breakpoint) {
			// >= 1024 touch devices
			if (matchMedia("(pointer: coarse)").matches) {
				const _this = this;

				$(".j-sub-menu-toggle").each(function () {
					if (this == _this) {
						$(this).addClass("dropdown-open");
					} else {
						$(this).removeClass("dropdown-open");
					}
				});
			}
		}
	});

	// close nav dropdown on large touch devices
	$(document).on("click", function (e) {
		if (!$(e.target).closest(".j-main-menu").length) {
			$(".j-sub-menu-toggle").each(function () {
				$(this).removeClass("dropdown-open");
			});
		}
	});

	$(document).on("click", ".j-toggle-sub-menu-links", function (e) {
		if ($(window).outerWidth() < lg_breakpoint) {
			e.preventDefault();

			if ($(this).parent().hasClass("open")) {
				$(this).parent().removeClass("open");
				$(this).parent().next().slideToggle(233);
			} else {
				$(".j-toggle-sub-menu-links").each(function () {
					if ($(this).parent().hasClass("open")) {
						$(this).parent().removeClass("open");
						$(this).parent().next().slideToggle(233);
					}
				});

				$(this).parent().addClass("open");
				$(this).parent().next().slideToggle(233);
			}
		}
	});

	$(document).on("click", ".j-close-sub-menu", function () {
		$(".j-main-menu").removeClass("show-nested");

		$(this).addClass("hidden");
		$(this).children(".text").addClass("hidden");

		$(".j-dropdown").removeClass("active");

		$(".j-toggle-sub-menu-links").each(function () {
			if ($(this).hasClass("open")) {
				$(this).removeClass("open");
				$(this).next().slideToggle();
			}
		});

		$(".j-mobile-header-icons").removeClass("hidden");
		$(".j-nav-connect").removeClass("hidden");
	});

	// Apply an active class to top level links whenever a child is also active
	if ($(".j-main-menu").length) {
		$(".j-main-menu > .list-item").each(function (index, el) {
			// var _isActive = false;
			if ($(this).find(".sub-menu-link.active").length) {
				const subMenuToggle = $(this)
					.find(".sub-menu-link.active")
					.parents(".sub-menu")
					.find(".j-toggle-sub-menu-links");
				const topLevelLink = $(this).find("a.top-level-link");

				// subMenuToggle.find('a').addClass('active');
				// subMenuToggle.find('.non-link-title').addClass('active');
				topLevelLink.addClass("active");

				if ($(window).outerWidth() < lg_breakpoint) {
					topLevelLink.trigger("click");
					subMenuToggle.trigger("click");
				}
			}
		});
	}

	// console.log($('.j-sub-menu-toggle .top-level-link').length);

	// // Open the nav to the current page on load
	// if ($('.j-sub-menu-toggle .top-level-link.active').length) {
	// 	console.log('we have one')
	// 	if ($(window).outerWidth() >= lg_breakpoint) {
	// 		$('.j-sub-menu-toggle .top-level-link.active').trigger('click');
	// 	}
	// }

	/* == Global Search ================================================== */

	$(document).on("click", ".j-toggle-search", function () {
		$(".j-search-popup").addClass("open");
		$(".j-close-search, .overlay").removeClass("hidden");
		$(".j-search-popup-input").focus();
	});

	$(document).on("click", ".j-close-search, .j-search-overlay", function () {
		$(".j-search-popup").removeClass("open");
		$(".j-close-search, .overlay").addClass("hidden");
	});

	/* == Search Page ==================================================== */

	$(document).on("click", ".j-search-filter-by", function () {
		const filter = $(this).attr("data-filter");
		const _this = this;

		$(".result-card").each(function () {
			if (JSON.parse($(this).attr("data-groups")).includes(filter)) {
				$(this).removeClass("result-hidden");
			} else {
				$(this).addClass("result-hidden");
			}
		});

		$(".j-search-filter-by").each(function () {
			if (_this === this) {
				$(this).removeClass("btn-outline");
			} else {
				$(this).addClass("btn-outline");
			}
		});
	});

	if (window.location.pathname === "/search") {
		$(".result-card").each(function () {
			if (JSON.parse($(this).attr("data-groups")).includes("products")) {
				$('.j-search-filter-by[data-filter="products"]').trigger(
					"click"
				);
				return false;
			} else if (
				JSON.parse($(this).attr("data-groups")).includes("blogs")
			) {
				$('.j-search-filter-by[data-filter="blogs"]').trigger("click");
				return false;
			} else if (
				JSON.parse($(this).attr("data-groups")).includes("recipes")
			) {
				$('.j-search-filter-by[data-filter="recipes"]').trigger(
					"click"
				);
				return false;
			}
		});
	}

	/* == Account Area =================================================== */

	$(document).on("click", ".j-view-password", function () {
		const input = $(this).parent().children("input");

		if (input.attr("type") === "password") {
			input.attr("type", "text");
		} else {
			input.attr("type", "password");
		}
	});

	$(document).on("click", ".j-show-forgotten-password", function (e) {
		e.preventDefault();
		$(".form-wrapper.login").addClass("hidden");
		$(".form-wrapper.f-password").removeClass("hidden");
		$(".form-wrapper.register").addClass("hidden");
	});

	$(document).on("click", ".j-show-login", function (e) {
		e.preventDefault();
		$(".form-wrapper.login").removeClass("hidden");
		$(".form-wrapper.f-password").addClass("hidden");
		$(".form-wrapper.register").addClass("hidden");

		// change history state
		window.history.pushState(
			{ page: "/account/login" },
			"",
			"/account/login"
		);
	});

	$(document).on("click", ".j-show-register", function (e) {
		e.preventDefault();
		$(".form-wrapper.login").addClass("hidden");
		$(".form-wrapper.f-password").addClass("hidden");
		$(".form-wrapper.register").removeClass("hidden");

		// change history state
		window.history.pushState(
			{ page: "/account/register" },
			"",
			"/account/register"
		);
	});

	// Toggle order click on acount page
	$(document).on("click", ".j-toggle-order", function () {
		const order = $(this).parent().attr("data-order");

		$(`.order-line-items[data-order="${order}"]`).slideToggle();
		$('.order-divider[data-order="${order}"]').toggleClass("hidden");
	});

	// Toggle order from header click on acount page
	$(document).on("click", ".j-toggle-order-from-head", function () {
		const order = $(this).attr("data-order");

		$(`.order-line-items[data-order="${order}"]`).slideToggle();
		$('.order-divider[data-order="${order}"]').toggleClass("hidden");
	});

	$(document).on("click", ".j-repurchase-order", function (e) {
		e.preventDefault();

		var btn = $(this);

		var text = $(this).text();
		btn.text("Adding products to cart...");

		const orderNo = $(this).attr("data-order");

		$(`.j-line-items[data-order="${orderNo}"]`)
			.find(".line-item")
			.each(function () {
				var reorder_variant_id = $(this).data("reorder_variant_id");
				var reorder_quantity = $(this).data("reorder_quantity");

				var properties = {};

				CartJS.addItem(
					reorder_variant_id,
					reorder_quantity,
					properties,
					{
						success: function (data, textStatus, jqXHR) {
							console.log("Added product");
						},
						error: function (jqXHR, textStatus, errorThrown) {
							console.log("Error: " + errorThrown + "!");
						},
					}
				);
			});

		setTimeout(function () {
			btn.text("Items are in your bag");
		}, 3000);

		setTimeout(function () {
			btn.text(text);
		}, 6000);
	});

	$(document).on("click", ".j-menu-dropdown-toggle", function () {
		const listContainer = $(this).siblings("nav").children("ul");
		const filters = listContainer.children("li");
		const filterHeight = filters.outerHeight();

		const listHeight = filters.length * (filterHeight + 25);

		if (listContainer.hasClass("open")) {
			listContainer.removeAttr("style");
			listContainer.removeClass("open");
			$(this).removeClass("open");
		} else {
			listContainer.css({ height: `${listHeight}px` });
			listContainer.addClass("open");
			$(this).addClass("open");
		}
	});

	/* == Other Listeners ================================================ */
	/* =================================================================== */

	/* == Newsletter ===================================================== */
	function overwriteMailChimpMessages() {
		const targets = document.querySelectorAll("#mce-error-response");

		const callback = function (mutationsList, observer) {
			for (const mutation of mutationsList) {
				if (mutation.type === "childList") {
					let message = mutation.target.innerHTML;

					if (
						message.includes(
							" to list Tick Tock Tea Consumer List - GDPR Compliant."
						)
					) {
						observer.disconnect();

						message = message.replace(
							" to list Tick Tock Tea Consumer List - GDPR Compliant.",
							"."
						);
						message = message + ".";

						mutation.target.innerHTML = message;
					}
				}
			}
		};

		for (const target of targets) {
			const observer = new MutationObserver(callback);
			observer.observe(target, { childList: true, characterData: true });
		}
	}

	overwriteMailChimpMessages();

	$(document).on("click", ".j-mailchimp-submit", function () {
		$(this).parents("form").find("input").removeClass("has-value");
	});

	/* == FAQ Search ===================================================== */

	// Custom selector to use insensitive casing

	$.expr[":"].containsIgnoreCase = function (a, i, m) {
		return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
	};

	$(document).on("keyup", "#faq-search-input", function (e) {
		if (e.key == "Enter") {
			e.preventDefault();
		}
	});

	$(document).on("submit", "#faq-search", function (e) {
		e.preventDefault();
		var search = $("#faq-search-input").val();
		var container = $(
			'.j-faq-questions-answers .faq-item .faq-answer p:containsIgnoreCase("' +
				search +
				'"),.j-faq-questions-answers .faq-item .faq-question span:containsIgnoreCase("' +
				search +
				'")'
		);

		$(".j-toggle-faq").each(function () {
			if ($(this).hasClass("open")) {
				// $(this).removeClass('open');
				// $(this).siblings('article').slideToggle(300);
				$(this).addClass("was-open");
			}
		});

		console.log(container.length);

		if (search.length >= 1) {
			if (container.length >= 1) {
				// close anything that's open

				// Get the first match
				var goToSection = container.first();

				container.each(function () {
					const question = $(this)
						.closest(".faq-item")
						.children(".j-toggle-faq");

					if (!question.hasClass("was-open")) {
						if (!question.hasClass("checked")) {
							question.addClass("checked");
							question.siblings("article").slideToggle(300);
							question.toggleClass("open");
						}
					} else {
						question.removeClass("was-open");
					}
				});

				// Scroll to the first match
				$("html, body").animate(
					{
						scrollTop: $(goToSection).offset().top - 200,
					},
					233
				);

				$(".j-no-results").fadeOut();
			} else {
				$(".j-no-results")
					.text(
						"Sorry, that search term hasn't returned any results. Please try again."
					)
					.fadeIn();
			}

			$(".j-toggle-faq").each(function () {
				if ($(this).hasClass("was-open")) {
					$(this).removeClass("open was-open");

					$(this).siblings("article").slideToggle(300);
				}

				$(this).removeClass("checked");
			});
		} else {
			$(".j-no-results")
				.text("Please enter a search term and try again.")
				.fadeIn();

			$(".j-toggle-faq").each(function () {
				if ($(this).hasClass("was-open")) {
					$(this).removeClass("open was-open");

					$(this).siblings("article").slideToggle(300);
				}

				$(this).removeClass("checked");
			});
		}
	});

	/* == Accordian Toggle =============================================== */

	$(document).on("click", ".j-toggle-accordian", function () {
		const _this = this;
		$(this).siblings("article").slideToggle();
		$(this).toggleClass("open");

		$(".j-toggle-accordian").each(function () {
			if ($(this).hasClass("open")) {
				if (_this !== this) {
					$(this).removeClass("open");
					$(this).siblings("article").slideToggle(300);
				}
			}
		});
	});

	/* == FAQ Toggle =============================================== */

	$(document).on("click", ".j-toggle-faq", function () {
		$(this).siblings("article").slideToggle(300);
		$(this).toggleClass("open");
	});

	/* == Toggle Filters =========================================== */

	$(document).on("click", ".j-filter-dropdown-toggle", function () {
		const listContainer = $(this).siblings("ul");
		const filters = listContainer.children("li");
		const filterHeight = filters.outerHeight();

		const listHeight =
			40 + filters.length * filterHeight + (filters.length - 1) * 15;

		if (listContainer.hasClass("open")) {
			listContainer.removeAttr("style");
			listContainer.removeClass("open");
			$(this).removeClass("open");
		} else {
			listContainer.css({ height: `${listHeight}px`, padding: "20px 0" });
			listContainer.addClass("open");
			$(this).addClass("open");
		}
	});

	$("input").on("blur", function (e) {
		// if (e.target.value || $(this).attr('required')) {
		if (e.target.value) {
			$(this).addClass("has-value");

			if (!e.target.checkValidity()) {
				$(this)
					.siblings(".error-message")
					.children(".message")
					.attr("aria-hidden", false);
			}
		} else {
			$(this).removeClass("has-value");
			$(this)
				.siblings(".error-message")
				.children(".message")
				.attr("aria-hidden", true);
		}
	});

	/* == Slick Carousels ================================================ */
	/* =================================================================== */

	/* == Homepage Hero ================================================== */

	$(".j-hero-carousel").slick({
		infinite: $(".j-hero-carousel").attr("data-slides") > 2 ? true : false,
		variableWidth: true,
        adaptiveHeight:true,
		dots: true,
		appendDots: $(".j-dots-container .dots"),
		arrows: true,
		swipe: false,
		swipeToSlide: false,
	});

	$(".j-hero-carousel").on(
		"beforeChange",
		function (event, slick, currentSlide, nextSlide) {
			// set the carousel background colour
			const nextStyle = $(slick.$slides[nextSlide]).attr("style");
			$(".j-carousel-bg").attr("style", nextStyle);

			// detect which direction we're going
			let direction;
			let firstSlide = false;
			let lastSlide = false;

			if (currentSlide === slick.$slides.length - 1) {
				// we're currently on the last slide
				direction = nextSlide === 0 ? "next" : "prev";
				lastSlide = true;
			} else if (currentSlide === 0) {
				// we're on the first slide
				direction = nextSlide === 1 ? "next" : "prev";
				firstSlide = true;
			} else {
				// we're somewhere in the middle
				direction = nextSlide > currentSlide ? "next" : "prev";
			}

			if (direction === "next") {
				const hiddenTransitions = 0;

				const nextArrow = $(this).parent().find(".slick-next");
				nextArrow.css({ "pointer-events": "none" });

				$(".j-slide-image").each(function (index) {
					const imageIndex = $(this).attr("data-slide");

					if (imageIndex < currentSlide) {
						$(this).fadeOut(300, function () {
							$(this).addClass("no-transition prev-image");
							$(this).removeClass("current-image");

							$(this).show();
						});
					} else if (imageIndex > nextSlide) {
						if (nextSlide != 0) {
							$(this).removeClass("current-image prev-image");
						} else {
							if (imageIndex == currentSlide + 1) {
								$(this).addClass("current-image");
							} else {
								$(this).fadeOut(300, function () {
									$(this).addClass("no-transition");
									$(this).removeClass(
										"current-image prev-image"
									);

									$(this).show();
								});
							}
						}
					} else {
						if (imageIndex == currentSlide && nextSlide == 0) {
							$(this).fadeOut(300, function () {
								$(this).addClass("no-transition");
								$(this).removeClass("current-image prev-image");

								$(this).show();
							});
						} else {
							$(this).addClass("current-image");
						}
					}
				});

				if (lastSlide) {
					// $(document).on('sliderTransitionEnd', function () {

					setTimeout(function () {
						$(".j-slide-image").each(function (index) {
							const imageIndex = $(this).attr("data-slide");

							$(this).addClass("no-transition");

							if (imageIndex <= -1) {
								$(this).removeClass("current-image");
								$(this).addClass("prev-image");
							} else if (imageIndex == 0) {
								$(this).removeClass("prev-image");
								$(this).addClass("current-image");
							} else {
								$(this).removeClass("current-image prev-image");
							}
						});

						// next tick
						setTimeout(function () {
							$(".j-slide-image").each(function () {
								$(this).removeClass("no-transition");
							});

							nextArrow.removeAttr("style");
						}, 400);
					}, 600);

					// });
				} else {
					$(".j-slide-image").each(function () {
						$(this).removeClass("no-transition");
					});

					// re-enable the slick arrow
					nextArrow.removeAttr("style");
				}
			} else {
				const prevArrow = $(this).parent().find(".slick-prev");
				prevArrow.css({ "pointer-events": "none" });

				$(".j-slide-image").each(function (index) {
					const imageIndex = $(this).attr("data-slide");

					if (imageIndex >= currentSlide) {
						$(this).removeClass("current-image prev-image");
					} else if (
						imageIndex == nextSlide ||
						imageIndex == nextSlide - 1
					) {
						$(this).removeClass("prev-image");
						$(this).addClass("current-image");
					} else if (
						imageIndex < nextSlide - 1 &&
						nextSlide != slick.$slides.length - 1
					) {
						$(this).removeClass("current-image");
						$(this).addClass("prev-image");
					} else if (nextSlide == slick.$slides.length - 1) {
						if (imageIndex == -1 || imageIndex == -2) {
							$(this).removeClass("prev-image");
							$(this).addClass("current-image");
						}
					}
				});

				if (firstSlide) {
					$(".j-slide-image").each(function (index) {
						const imageIndex = $(this).attr("data-slide");

						$(this).addClass("no-transition");

						if (imageIndex < slick.$slides.length - 2) {
							$(this).removeClass("current-image");
							$(this).addClass("prev-image");
						} else if (imageIndex >= slick.$slides.length) {
							$(this).removeClass("prev-image current-image");
						} else {
							$(this).removeClass("prev-image");
							$(this).addClass("current-image");
						}

						const _this = $(this);

						// next tick
						setTimeout(function () {
							_this.removeClass("no-transition");

							prevArrow.removeAttr("style");
						});
					});
				} else {
					prevArrow.removeAttr("style");
				}
			}
		}
	);

	/* == Global Product Carousel ======================================== */

	$(".j-product-carousel").slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		responsive: [
			{
				breakpoint: 769,
				settings: "unslick",
			},
			// {
			// 	breakpoint: 1023,
			// 	settings: {
			// 		slidesToShow: 3,
			// 		swipe: true,
			// 		swipeToSlide: true
			// 	}
			// },
			// {
			// 	breakpoint: 639,
			// 	settings: {
			// 		variableWidth: true,
			// 		arrows: true,
			// 		swipe: true,
			// 		swipeToSlide: true
			// 	}
			// }
		],
	});

	/* == Homepage Stockists ============================================= */

	$(".j-stockist-carousel").slick({
		infinite: true,
		autoplay: true,
		variableWidth: true,
		centerMode: true,
		arrows: false,
		dots: true,
		swipeToSlide: true,
	});

	$(".slick-slider").show(); // Show all carousels once page loaded - must be after all slick calls

	/* == Match Height =================================================== */
	/* =================================================================== */

	/* == Product Listing Page =========================================== */

	$(".j-product-listing-title").matchHeight();
	$(".j-product-listing-tagline").matchHeight();

	$(window).on("resize", function () {
		$(".j-product-listing-title").matchHeight();
		$(".j-product-listing-tagline").matchHeight();
	});

	/* == Peaceful Nights Page =========================================== */

	$(".j-title").matchHeight();

	$(window).on("resize", function () {
		if ($(window).outerWidth() > 639) {
			$(".j-title").matchHeight();
		}
	});

	/* == Article Listing Page =========================================== */

	$(".j-article-listing-excerpt").matchHeight();
	$(".j-article-meta").matchHeight();

	$(window).on("resize", function () {
		if ($(window).outerWidth() > 639) {
			$(".j-article-listing-excerpt").matchHeight();
			$(".j-article-meta").matchHeight();
		}
	});

	/* == WYSIWYG Overrides ============================================== */
	/* =================================================================== */

	// function enhanceWYSIWYG() {
	// 	const wysiwyg = $('.j-deluxe-wysiwyg');

	// 	// Grid Cell Class Names
	// 	const full = 'cell medium-10 medium-offset-1 large-8 large-offset-2';
	// 	const halfLeft = 'cell medium-5 medium-offset-1 large-4 large-offset-2';
	// 	const halfRight = 'cell medium-5 large-4';

	// 	// Grab any text nodes not wrapped in a tag
	// 	const textNodes = wysiwyg.contents().filter(function() {
	// 		return this.nodeType === Node.TEXT_NODE;
	// 	});

	// 	if (textNodes.length) {
	// 		Array.from(textNodes).forEach(function(node) {
	// 			if (node.nodeValue.trim().length > 1) {
	// 				const container = document.createElement('div');
	// 				container.className = full;

	// 				node.after(container);
	// 				container.appendChild(node);
	// 			} else {
	// 				$(node).remove();
	// 			}

	// 		});
	// 	}

	// 	// Wrap all non image or blockquote children in the right column width
	// 	const children = wysiwyg.children('div, ul, p, h1, h2, h3, h4, h5, h6');

	// 	children.each(function () {
	// 		$(this).removeClass();
	// 		$(this).removeAttr('style');
	// 		$(this).addClass(full);
	// 	});

	// 	// Divs
	// 	// const divs = wysiwyg.children('div, ul');

	// 	// divs.each(function() {
	// 	// 	$(this).removeClass();
	// 	// 	$(this).removeAttr('style');
	// 	// 	$(this).addClass(full);
	// 	// });

	// 	// Images
	// 	const images = wysiwyg.find('img');

	// 	images.each(function() {
	// 		const [ alt, meta = '' ] = $(this).attr('alt').split(' - ');

	// 		// Create New Image Container
	// 		const container = document.createElement('div');

	// 		if (meta) {
	// 			switch (meta.toLowerCase()) {
	// 				case 'main':
	// 				case 'banner':
	// 					container.className = `${full} image image-full`;
	// 					break;
	// 				case 'split-left':
	// 					container.className = `${halfLeft} image`;
	// 					break;
	// 				case 'split-right':
	// 					container.className = `${halfRight} image`;
	// 					break;
	// 				default:
	// 					container.className = `${full} image image-full`;
	// 					break;
	// 			}
	// 		} else {
	// 			container.className = `${full} image image-full`;
	// 		}

	// 		// Create a New Image Wrapper
	// 		const wrapper = document.createElement('div');
	// 		wrapper.className = `image-wrapper ${meta ? meta.toLowerCase() : 'main'}`;

	// 		// Nest the Wrapper inside the Container
	// 		container.appendChild(wrapper);

	// 		// Create a clone of the image
	// 		const src = $(this).attr('src');

	// 		// Create a new image
	// 		const image = document.createElement('img');
	// 		image.src = src;
	// 		image.alt = alt;

	// 		// Nest the Image inside the new Wrapper
	// 		wrapper.appendChild(image);

	// 		// Remove the original parent(s)
	// 		// if ($(this).parent('span').length) {
	// 		// 	const parent = $(this).parents('p.p1');

	// 		// 	parent.before(container);
	// 		// 	parent.remove();
	// 		// } else if($(this).parent('div').length) {
	// 		// 	const parent = $(this).parent('div');

	// 		// 	parent.before(container);
	// 		// 	parent.remove();
	// 		// }

	// 		const parent = $(this).parent();
	// 		parent.before(container);
	// 		parent.remove();

	// 	});

	// 	// Block Quotes
	// 	const quotes = wysiwyg.find('blockquote');

	// 	quotes.each(function() {
	// 		const [body, caption] = $(this).children('p');
	// 		const citation = $(caption).find('em')[0] || undefined;

	// 		const container = document.createElement('div');
	// 		container.className = 'cell grid-x grid-x-padded quote-wrapper';

	// 		let quoteColor = null;
	// 		let quoteTextColor = null;

	// 		if (window.ticktock && window.ticktock.article && window.ticktock.article.tags && window.ticktock.article.tags.length) {
	// 			for (tag of window.ticktock.article.tags) {
	// 				if (tag.includes('quote-colour:')) {
	// 					if (tag.includes('quote-colour:@')) {
	// 						quoteColor = `${tag.replace('quote-colour:@', 'var(--')})`;
	// 					} else if (tag.includes('quote-colour:#')) {
	// 						quoteColor = tag.replace('quote-colour:#');
	// 					}
	// 				}

	// 				if (tag.includes('quote-text-colour:')) {
	// 					if (tag.includes('quote-text-colour:@')) {
	// 						quoteTextColor = `${tag.replace('quote-text-colour:@', 'var(--')})`;
	// 					} else if (tag.includes('quote-text-colour:#')) {
	// 						quoteTextColor = tag.replace('quote-text-colour:#');
	// 					}
	// 				}
	// 			}
	// 		}

	// 		if (quoteColor || quoteTextColor) {
	// 			container.style = `--background: ${quoteColor || 'var(--white)'}; --foreground: ${quoteTextColor || 'var(--primary-blue)'}; --`
	// 		}

	// 		let quoteIconColor = (quoteTextColor == 'var(--white)' || quoteTextColor.toLowerCase() === '#fff' || quoteTextColor.toLowerCase() === '#ffffff') ? 'white' : 'blue';

	// 		const quoteMarks = document.createElement('div');
	// 		quoteMarks.className = `quote-marks ${quoteIconColor}`;

	// 		const figure = document.createElement('figure');
	// 		figure.className = `${full} text-center`;

	// 		const blockquote = document.createElement('blockquote');
	// 		blockquote.className = 'intro-text';
	// 		blockquote.textContent = body.textContent;

	// 		const figcaption = document.createElement('figcaption');
	// 		figcaption.className = 'small-body';

	// 		if (citation) {
	// 			figcaption.innerHTML = caption.textContent.split("-")[0] + ' - ' + '<cite>' + citation.textContent + '</cite>';
	// 		} else {
	// 			figcaption.textContent = caption.textContent;
	// 		}

	// 		// append

	// 		figure.appendChild(blockquote);
	// 		figure.appendChild(figcaption);
	// 		container.appendChild(quoteMarks);
	// 		container.appendChild(figure);

	// 		$(this).before(container);
	// 		$(this).remove();
	// 	});

	// }

	function enhanceWYSIWYG() {
		const wysiwyg = $(".j-deluxe-wysiwyg");

		// Images
		const images = wysiwyg.find("img");

		images.each(function () {
			const [alt, meta = ""] = $(this).attr("alt").split(" - ");

			// Create New Image Container
			const container = document.createElement("div");

			if (meta) {
				switch (meta.toLowerCase()) {
					case "main":
					case "banner":
						container.className = `image image-full`;
						break;
					case "split-left":
						container.className = `image split-left`;
						break;
					case "split-right":
						container.className = `image split-right`;
						break;
					default:
						container.className = `image image-full`;
						break;
				}
			} else {
				container.className = `image image-full`;
			}

			// Create a New Image Wrapper
			const wrapper = document.createElement("div");
			wrapper.className = `image-wrapper ${
				meta ? meta.toLowerCase() : "main"
			}`;

			// Nest the Wrapper inside the Container
			container.appendChild(wrapper);

			// Create a clone of the image
			const src = $(this).attr("src");

			// Create a new image
			const image = document.createElement("img");
			image.src = src;
			image.alt = alt;

			// Nest the Image inside the new Wrapper
			wrapper.appendChild(image);

			const parent = $(this).parent();
			parent.before(container);
			parent.remove();
		});

		// Block Quotes
		const quotes = wysiwyg.find("blockquote");

		console.log(quotes);

		quotes.each(function () {
			const [body, caption] = $(this).children("p");
			const citation = $(caption).find("em")[0] || undefined;

			const container = document.createElement("div");
			container.className = "quote-wrapper";

			let quoteColor = null;
			let quoteTextColor = null;

			if (
				window.ticktock &&
				window.ticktock.article &&
				window.ticktock.article.tags &&
				window.ticktock.article.tags.length
			) {
				for (tag of window.ticktock.article.tags) {
					if (tag.includes("quote-colour:")) {
						if (tag.includes("quote-colour:@")) {
							quoteColor = `${tag.replace(
								"quote-colour:@",
								"var(--"
							)})`;
						} else if (tag.includes("quote-colour:#")) {
							quoteColor = tag.replace("quote-colour:#");
						}
					}

					if (tag.includes("quote-text-colour:")) {
						if (tag.includes("quote-text-colour:@")) {
							quoteTextColor = `${tag.replace(
								"quote-text-colour:@",
								"var(--"
							)})`;
						} else if (tag.includes("quote-text-colour:#")) {
							quoteTextColor = tag.replace("quote-text-colour:#");
						}
					}
				}
			}

			if (quoteColor || quoteTextColor) {
				container.style = `--background: ${
					quoteColor || "var(--white)"
				}; --foreground: ${
					quoteTextColor || "var(--primary-blue)"
				}; --`;
			}

			let quoteIconColor =
				quoteTextColor == "var(--white)" ||
				quoteTextColor.toLowerCase() === "#fff" ||
				quoteTextColor.toLowerCase() === "#ffffff"
					? "white"
					: "blue";

			const quoteMarks = document.createElement("div");
			quoteMarks.className = `quote-marks ${quoteIconColor}`;

			const figure = document.createElement("figure");
			figure.className = `text-center`;

			const blockquote = document.createElement("blockquote");
			blockquote.className = "intro-text";
			blockquote.textContent = body.textContent;

			const figcaption = document.createElement("figcaption");
			figcaption.className = "small-body";

			if (citation) {
				figcaption.innerHTML =
					caption.textContent.split("-")[0] +
					" - " +
					"<cite>" +
					citation.textContent +
					"</cite>";
			} else {
				figcaption.textContent = caption.textContent;
			}

			// append

			figure.appendChild(blockquote);
			figure.appendChild(figcaption);
			container.appendChild(quoteMarks);
			container.appendChild(figure);

			$(this).before(container);
			$(this).remove();
		});
	}

	if ($(".j-deluxe-wysiwyg").length) {
		enhanceWYSIWYG();
	}

	/* == MC Terms checkbox state ======================================== */
	/* =================================================================== */

	$(document).on("change", "#terms-checkbox", function () {
		if ($(this).is(":checked")) {
			$(".mc-section-button").prop("disabled", false);
		} else {
			$(".mc-section-button").prop("disabled", true);
		}
	});

	/* == Parallax ======================================================= */
	/* =================================================================== */

	const parallaxSections = {};

	function initialiseSpotlightParallax() {
		$(".section--spotlight")
			.find(".section")
			.each(function (index) {
				const containerName = `spotlight-parallax-section-${index}`;
				const parallaxName = `spotlight-parallax-item-${index}`;

				$(this).addClass(containerName);

				$(this)
					.find(".j-parallax-image")
					.addClass(parallaxName)
					.attr("data-rellax-speed", "0.5");

				$(this)
					.find(".j-parallax-sticker")
					.addClass(parallaxName)
					.attr("data-rellax-speed", "1");

				parallaxSections[`spotlightRellax${index}`] = new Rellax(
					`.${parallaxName}`,
					{ wrapper: `.${containerName}`, relativeToWrapper: true }
				);
			});

		if ($(window).outerWidth() > 639) {
			for (section in parallaxSections) {
				parallaxSections[section].refresh();
			}
		}
	}

	initialiseSpotlightParallax();

	$(window).on("resize", function () {
		for (section in parallaxSections) {
			parallaxSections[section].destroy();
		}

		initialiseSpotlightParallax();
	});

	function sanitizeMCreponse(resp) {
		var msg = "";

		var index = -1;
		try {
			var parts = resp.msg.split(" - ", 2);
			if (parts[1] === undefined) {
				msg = resp.msg;
			} else {
				var i = parseInt(parts[0], 10);
				if (i.toString() === parts[0]) {
					index = parts[0];
					msg = parts[1];
				} else {
					index = -1;
					msg = resp.msg;
				}
			}
		} catch (e) {
			index = -1;
			msg = resp.msg;
		}
		return msg;
	}

	if ($(".j-slide-image iframe").length) {
		var iframe = $(".j-slide-image iframe");
		var player = new Vimeo.Player(iframe);

		$(document).on("click", ".j-vol-toggle", function (e) {
			e.preventDefault();
			$(this).toggleClass("active");

			console.log("Vol reached");

			if ($(this).hasClass("active")) {
				player.setVolume(1);
			} else {
				player.setVolume(0);
			}
		});
	}

	$(".j-sp-image-carousel").slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: true,
		dots: true,
	});

	// Campaign template - tabs

	$(document).on("click", ".j-sp-tab", function (e) {
		e.preventDefault();
		var tab = $(this).data("tab");
		$(this).addClass("active").siblings().removeClass("active");

		$('.tabbed-blocks .block[data-block="' + tab + '"]')
			.addClass("active")
			.siblings()
			.removeClass("active");
	});

	AOS.init();

	if($(".mc-form-section").length){
		$(".mc-form-section").ajaxChimp({
			url: "https://dragonflytea.us8.list-manage.com/subscribe/post?u=6194950d1adc46301ff813b9a&amp;id=d7e6daf01d",
			callback: function (resp) {
				console.log(resp);
				console.log("MAIL CHIMP request sent ")
				if (resp.result === "success") {
					$(".mc-form-section .mc-message.error").hide().html("");
					$(".mc-form-section .mc-message.success").show().html(resp.msg);
				} else {
					console.log(resp.msg);
	
					$(".mc-form-section .mc-message.success").hide().html("");
	
					var msg = sanitizeMCreponse(resp);
	
					if (msg.includes("is already subscribed")) {
						$(".mc-form-section .mc-message.error")
							.show()
							.html("You are already subscribed");
					} else {
						$(".mc-form-section .mc-message.error")
							.show()
							.html(resp.msg);
					}
				}
			},
		});
	}
	

	/* == Contact us form logic ============================================== */

	if($(".template-contact-us")){
		console.log("temnplate contact us")

		//product variant list logic 
		// if($('[data-product-select]')){
		// 	$('[data-product-select]').on("change",function(e){
				
		// 		const variantList = $(this).siblings("[data-variant-select]");
		// 		//all options
		// 		const variantOptions = variantList.children('option:not(:first-child)');
				
		// 		let currentProduct = $(this).find(":selected");
		// 		let currentProductId = currentProduct.data('productId')

		// 		if(currentProduct.data("hasVariants")){
		// 			//Set the first value for the variants dropdown
		// 			const firstValue = variantList.children(`option[data-belongs-to='${currentProductId}']:not(:first-child)`).first().val();
		// 			variantOptions.removeClass("hidden");
		// 			variantList.val(firstValue);
					
		// 			//reveal dropdown
		// 			variantList.slideDown();
		// 			variantList.children(`option:not(:first-child, [data-belongs-to='${currentProductId}'])`).addClass("hidden");
		// 			//show relevant options
		// 			variantOptions.attr("disabled",false);
		// 		}
		// 		else{
		// 			//close dropdown
		// 			variantList.slideUp();
		// 			variantOptions.addClass("hidden");
		// 			variantOptions.attr("disabled",true);
		// 			variantList.val("Default variant")
		// 		}
		//    })	
		// }
		
		//form change logic
		const reasonSelect = $("#reason");
		$('.trigger-buttons').hide();
		reasonSelect.on("change",function(e){
			const reason = reasonSelect.find("option:selected").data("handle");
			  if (!$(this).find("option:selected").is(":disabled")) {
				$('.trigger-buttons').show();
			}
			  // Hide all the form-builder-component divs and disable all the fields
			  $(".form-builder-component").addClass("hidden");
			  $(".form-builder-component :input").attr("disabled", true);

			  // Show the div with the selected category and remove disabled on fields
			  $(`.form-builder-component[data-category="${reason}"]`).removeClass("hidden");
			  $(`.form-builder-component[data-category="${reason}"] :input`).removeAttr("disabled");
			  
			  $(".form-builder-component .field-label").matchHeight({rows:false});
		})

		//Need to check if url contains reason parameter to show the form again as it errored out
		const urlParams = new URLSearchParams(window.location.search);
		const reasonParam = urlParams.get("contact[reason]");
		if(reasonParam){
			console.log("found reason parameter")
			reasonSelect.val(reasonParam);
			reasonSelect.trigger("change");
			$('html,body').animate({
				scrollTop: $(".info-messages").offset().top
			},'slow');
			
		}
		
		//submission logic
		const contactForm = $('#contact_form button');
		var contactEmailField = $("#contact_form input[type='email']");

		contactForm.on("click", function(event){
			event.preventDefault();
			//reseet error fields
			$(".error-field").hide();
			//Email validation
			if(!$("#contact_form input[type=email]:not([disabled])").get(0).checkValidity() ){
				$("#contact_form input[type=email]:not([disabled]) + .error-field").show();
				return false;
			}
			if(!$("#contact_form input[type=checkbox]:not([disabled])#accept").get(0).checkValidity()){
				$(".trigger-buttons .error-field").show();
				return false;
			}
			// console.log($("#contact_form input[type=email]:not([disabled])").get(0).checkValidity());

			// console.log("active email field", $("#contact_form input[type=email]:not([disabled])"))
			// contactEmailField = $("#contact_form input[type='email']:not([disabled])");
			const subscribeCheckbox = $("#contact_form [data-klaviyo-sub-checkbox]")

			if(subscribeCheckbox.is(":checked")){
				const mceForm = $("#mc-embedded-subscribe-form-contact")
				console.log("The subscribe flow HAS BEEN STARTED");
				const hiddenEmail = $("#mce-email");
				// hiddenEmail.val(contactEmailField.val());
				// console.log("MC VAL", hiddenEmail.val());
				console.log("MCE FORM", mceForm);
				mceForm.ajaxChimp({
					url: 'https://dragonflytea.us8.list-manage.com/subscribe/post?u=6194950d1adc46301ff813b9a&amp;id=08c570f869',
					callback: function (resp) {
						console.log(resp);
						console.log("MAIL CHIMP request sent ")
						if (resp.result === "success") {
							$(".mc-form-section .mc-message.error").hide().html("");
							$(".mc-form-section .mc-message.success").show().html(resp.msg);
						} else {
							console.log(resp.msg);
			
							$(".mc-form-section .mc-message.success").hide().html("");
			
							var msg = sanitizeMCreponse(resp);
			
							if (msg.includes("is already subscribed")) {
								$(".mc-form-section .mc-message.error")
									.show()
									.html("You are already subscribed");
							} else {
								$(".mc-form-section .mc-message.error")
									.show()
									.html(resp.msg);
							}
						}
					},
				})
				//uncomment when done debugging
				mceForm.trigger( "submit" );
			}
			//uncomment when done debugging
			$(this).parents('#contact_form').trigger( "submit" );

		})
		// console.log("contact fields: ", contactEmailField);
		contactEmailField.on('input', function () {
			const hiddenEmail = $("#mce-email");
			console.log("MC VAL", hiddenEmail.val());
			hiddenEmail.val($(this).val());
		});

		

	}	


});
